import { InjectionToken, ValueProvider } from '@angular/core';
import plotly from 'plotly.js-dist';

const Plotly = new InjectionToken('plotly');
const PlotlyProvider: ValueProvider = { provide: Plotly, useValue: plotly };
export { Plotly, PlotlyProvider };
